import React from 'react';
import { HealthCheckModel } from '../../../Helper';
interface Props {
  setHealthCheckFilter: (modelName:string | null) => void;
  filterModelName: string | null;
  healthCheckData: HealthCheckModel[] ;
}

const HealthSidebar = ({setHealthCheckFilter , filterModelName ,healthCheckData} : Props) => {
  const modelsFailed = healthCheckData.filter((model) => model.status !== "Success");

  // Remove duplicates based on modelName
  const ModelHealth = healthCheckData
  ? Array.from(new Map(healthCheckData.map((model) => [model.modelName, model])).values())
  : [];

  return (
    <div className="Health-sidebar">
      {ModelHealth.map((modelsStatus) => { 
        const isModelHasFailed = modelsFailed.some((model) => model.modelName === modelsStatus.modelName) ? "Failed" : "Success";
      return (
        <div className={`Model-health ${modelsStatus.modelName === filterModelName && "active"}`} 
          key={modelsStatus.modelName} onClick={ () => setHealthCheckFilter(modelsStatus.modelName)}>
          <p className="Model-name">{modelsStatus.modelName}</p>
          <p className={`Model-status ${isModelHasFailed}`}>
            {isModelHasFailed}
          </p>
        </div>
      )})}
    </div>   
  );
};

export default HealthSidebar;
